/** selector: class or data-attribute (STRING) (not required if objects are set)
 *  objects:  NODELIST if objects ( not required if selector is set)
 *  confirmation: Show confirmation Text (TRUE or FALSE) (default "false")
 *  type: Set type of InfoBanner Functionality (STRING) (default "show") ('copy', 'delete', 'show')
 *
 *  Example:
 *    elements: [{
              selector: 'data-copy',
              confirmation: false,
              type: 'copy'
          },{
              selector: 'data-share',
              confirmation: false,
              type: 'share'
          },
          {
              selector: 'data-delete',
              confirmation: true,
              type: 'delete'
          }]
 *
 */

import './op-actions.scss';

class OPActions {
    constructor (options) {
        this.debug = false;
        this.infoBannerHTML = null;
        this.elements = {};
        this.confirmationOverlay = document.querySelector('[data-confirmation]');
        this.$confirmElement = null;
        this.confirmationAnswer = null;

        this.defaults = {
            elements: null,
            type: 'show',
            confirmation: false,
            timer: 3000
        };

        this.settings = Object.assign({}, this.defaults, options);
        this.init();
    }

    init () {
        if (this.debug) {
            console.log('init InfoBanner');
        }

        this.elements = [].slice.call(this.settings.elements);

        this.elements.forEach((value, index) => {
            this.elements[index].objects = document.querySelectorAll('[' + value.selector + ']');

            if (this.elements[index].objects.length > 0) {
                this.setEvent(this.elements[index]);
            }
        });
    }

    setEvent (element) {
        let type = this.settings.type;

        if (typeof element.type !== 'undefined') {
            type = element.type;
        }

        element.objects.forEach((value) => {
            value.addEventListener('click', (e) => {
                e.preventDefault();

                let banner = null;

                if (element.confirmation) {
                    this.$confirmElement = value;
                    this.showConfirmation(type, value, value.getAttribute(element.selector));
                } else {
                    banner = this.addBanner(type, value, value.getAttribute(element.selector));
                }

                if (banner !== null) {
                    banner.classList.add('is--visible');

                    setTimeout(() => {
                        banner.classList.remove('is--visible');
                    }, this.settings.timer);
                }
            });
        });

        this.confirmationOverlay.addEventListener('click', (e) => {
            this.confirmationEvent(e);
        });
    }

    addTextarea (datavalue) {
        const textarea = document.createElement('textarea');
        textarea.textContent = datavalue;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();

        document.execCommand('copy');
        document.body.removeChild(textarea);
    }

    confirmationEvent (e) {
        let banner;

        const type = e.target.getAttribute('data-confirm');

        if (type === 'yes') {
            banner = this.addBanner('delete', this.$confirmElement, 'data-delete');
            banner.classList.add('is--visible');

            setTimeout(() => {
                banner.classList.remove('is--visible');
            }, this.settings.timer);
        }

        if (type === 'no') {
            this.hideConfirmation();
        }
    }

    hideConfirmation () {
        this.confirmationOverlay.classList.remove('overlay--open');
    }

    showConfirmation () {
        this.confirmationOverlay.classList.add('overlay--open');
    }

    addBanner (type, object, datavalue, callback) {
        const banner = document.createElement('div');
        const content = document.createElement('div');

        banner.classList.add('op-actions__banner');
        content.classList.add('op-actions__banner__content');
        banner.appendChild(content);

        switch (type) {
        case 'share':
            content.innerHTML = '<p>Der Share-Link wurde in die Zwischenablage kopiert.</p>';
            this.addTextarea(datavalue);
            document.body.appendChild(banner);
            break;
        case 'delete':
            if (object.getAttribute('data-url') !== null) {
                const deleteRequest = new XMLHttpRequest();

                deleteRequest.addEventListener('load', () => {
                    const response = JSON.parse(deleteRequest.response);

                    if (response.success) {
                        content.innerHTML = '<p>' + datavalue + ' wurde gelöscht.</p>';
                        document.body.appendChild(banner);

                        if (this.confirmationOverlay.classList.contains('overlay--open')) {
                            this.hideConfirmation();
                        }
                        object.closest('[data-kitchen-item]').remove();
                    } else {
                        content.innerHTML = '<p>' + datavalue + ' konnte nicht gelöscht werden.</p>';
                    }
                });

                deleteRequest.open('GET', object.getAttribute('data-url'));
                deleteRequest.send();
            } else {
                content.innerHTML = '<p>' + datavalue + ' konnte nicht gelöscht werden.</p>';
            }
            document.body.appendChild(banner);
            break;
        case 'show':
            content.innerHTML = '<p>' + datavalue + '</p>';
            document.body.appendChild(banner);
            break;
        }

        return banner;
    }
}

export { OPActions };
